var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasStorageDepleteShared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 60 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m45.09 22h3.91c1.1032-0.0033 1.9967-0.8968 2-2v-6c-0.0033-1.1032-0.8968-1.9967-2-2h-4.4z",
    fill: "#547580"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#35495e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 6.01v-3.51c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5v3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 0c1.3807 0 2.5 1.1193 2.5 2.5v3.5h-5v-3.5c0-1.3807 1.1193-2.5 2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 6v-3.5c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5v3.51z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.85 28.15c1.4125-0.58496 2.6968-1.4411 3.78-2.52 3.2875-3.2889 4.2707-8.234 2.4914-12.53-1.7794-4.2963-5.9711-7.0982-10.621-7.0996h-22c-5.501-0.005236-10.235 3.886-11.295 9.2839-1.0601 5.3979 1.851 10.791 6.9454 12.866l5.87 0.85h18.96z",
    fill: "#f55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.017 18h-0.066c-0.2647-0.017209-0.51171-0.13888-0.68669-0.33824s-0.26358-0.46007-0.24631-0.72476c0.23625-3.4419 2.5233-6.4023 5.794-7.5 0.52467-0.17425 1.0913 0.10983 1.2655 0.6345 0.17425 0.52467-0.10983 1.0913-0.6345 1.2655-2.4992 0.84161-4.2466 3.1042-4.429 5.735-0.037742 0.52283-0.47281 0.92779-0.997 0.928z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6 25h2.8c0.47527-9.7e-5 0.88495 0.33433 0.98 0.8l1.6 8c0.06006 0.29426-0.0153 0.59992-0.20526 0.83254-0.18996 0.23261-0.47441 0.36753-0.77474 0.36746h-6c-0.30032 6.1e-5 -0.58477-0.13486-0.77474-0.36746-0.18996-0.23261-0.26533-0.53828-0.20526-0.83254l1.6-8c0.095054-0.46567 0.50473-0.8001 0.98-0.8z",
    fill: "#3f5c6c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m34.6 25h2.8c0.47527-9.7e-5 0.88495 0.33433 0.98 0.8l1.6 8c0.06006 0.29426-0.0153 0.59992-0.20526 0.83254-0.18996 0.23261-0.47441 0.36753-0.77474 0.36746h-6c-0.30032 6.1e-5 -0.58477-0.13486-0.77474-0.36746-0.18996-0.23261-0.26533-0.53828-0.20526-0.83254l1.6-8c0.09505-0.46567 0.50473-0.8001 0.98-0.8z",
    fill: "#3f5c6c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m59 18v17h-4v-16h-4v-4h5c1.6569 0 3 1.3431 3 3z",
    fill: "#35495e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m24.265 25c-0.69395 3.9e-4 -1.3851-0.08731-2.057-0.261-1.2121-0.28888-2.3076-0.9397-3.141-1.866-1.0363-1.369-1.3525-3.1522-0.85-4.794l0.419-1.551 1.045 1.187c0.25379 0.29846 0.59364 0.51117 0.973 0.609 0.10594 0.02442 0.21429 0.03683 0.323 0.037 0.36174 0.0032 0.70968-0.13872 0.966-0.394 0.27869-0.28754 0.39176-0.69722 0.3-1.087-0.0899-0.34982-0.23979-0.6814-0.443-0.98-0.16785-0.25973-0.30225-0.53961-0.4-0.833-0.24877-1.0791 0.06032-2.2111 0.823-3.014 0.32479-0.39588 0.6745-0.77064 1.047-1.122 0.173-0.171 0.323-0.318 0.469-0.47l1.414-1.461 0.051 2.079c0 0.126 0.012 0.25 0.025 0.372 0.07901 0.78362 0.4469 1.5098 1.032 2.037l0.293 0.276c0.78052 0.67762 1.478 1.4453 2.078 2.287 0.57078 0.84081 0.98854 1.7758 1.234 2.762 0.33526 1.4117 0.04355 2.8994-0.8 4.08-1.1755 1.4241-2.9571 2.2059-4.801 2.107z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m59 36h-58c-0.55228 0-1-0.44772-1-1s0.44772-1 1-1h58c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1z",
    fill: "#95a5a5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.033179 0 0 .033179 34.661 -3.3182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.07 317.79-57.346-33.939v-61.051c0-4.267-3.459-7.726-7.726-7.726s-7.726 3.459-7.726 7.726v61.051l-54.175 32.063c-3.673 2.173-4.887 6.912-2.714 10.584 1.443 2.438 4.016 3.792 6.657 3.792 1.338 0 2.693-0.348 3.928-1.078l54.03-31.978 57.202 33.854c1.235 0.731 2.59 1.078 3.928 1.078 2.641 0 5.214-1.355 6.657-3.792 2.173-3.672 0.958-8.411-2.715-10.584z",
    fill: "#efecef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 116.55,
    r: 116.55,
    fill: "#62a4fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.24 20.652c13.018 18.811 20.652 41.634 20.652 66.243 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.243-20.652 21.035 30.395 56.139 50.31 95.901 50.31 64.37 0 116.55-52.182 116.55-116.55 1e-3 -39.762-19.915-74.866-50.31-95.901z",
    fill: "#5392f9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 74.927,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 116.55c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.151-19.216-42.105-31.317-69.888-31.317z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 395.45,
    cy: 395.45,
    r: 116.55,
    fill: "#b3e59f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.69 299.55c13.018 18.811 20.652 41.634 20.652 66.242 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.242-20.652 21.035 30.395 56.139 50.31 95.901 50.31 64.37 1e-3 116.55-52.181 116.55-116.55 0-39.762-19.916-74.866-50.31-95.901z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 395.45,
    cy: 353.82,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.45 395.45c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.151-19.216-42.105-31.317-69.888-31.317z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 395.45,
    r: 116.55,
    fill: "#e27f86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.8 299.55c13.018 18.811 20.652 41.634 20.652 66.242 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.243-20.652 21.036 30.395 56.14 50.311 95.902 50.311 64.37 0 116.55-52.182 116.55-116.55 0-39.762-19.916-74.866-50.311-95.901z",
    fill: "#df646e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 353.82,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.55 395.45c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.152-19.216-42.105-31.317-69.888-31.317z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStorageDepleteShared);
export default __webpack_public_path__ + "static/media/gasStorage_deplete-shared.76f0e7ea5086a572d6bb537c62c342b2.svg";
export { ForwardRef as ReactComponent };